import type { PropsWithChildren } from "react";
import type { Props } from "./ImportCsvDataContext";
import { ImportCsvDataContext } from "./ImportCsvDataContext";

export const ImportCsvDataContextProvider = ({ pageState, setPageState, children }: PropsWithChildren<Props>) => {
  return <ImportCsvDataContext value={{ pageState, setPageState }}>{children}</ImportCsvDataContext>;
};
